module.exports = __webpack_public_path__ + "media/images/hojita-ec0377791501dbc0555b1c63107a0298.png";